<!-- Color Light-Blue  #1a6fb0 -->
<template>
  <div class="bg-light">
    <navbar evalExtern informExtern/>
    <main class="" style="padding-top: 0rem;">
      <section class="mx-auto" style="max-width: 1200px">
        <div class="px-0 px-xl-5 workingIcon">
          <div class="container py-5 mb-lg-3">
            <div class="row justify-content-center pt-lg-4 text-center">
              <div class="col-lg-7 col-md-7 col-sm-9">
                <h1 class="display-404">Neu</h1>
                <h2 class="h3 mb-4">
                  Unser neuer Marktplatz für Gebrauchtküchen inkl. Lieferung und Aufbau
                  kommt!
                </h2>
                <div class="widget pb-2 mb-5 pt-4">
                  <h3 class="widget-title pb-0 mb-2 text-left">Klingt interessant?</h3>
                  <p class="py-0 mt-0 font-size-xs text-left">Lass dich benachrichtigen, sobald es losgeht</p> 
                  <form class="needs-validation" novalidate v-on:submit="shopFormSubmit" id="shopForm">
                    <div class="input-group input-group-overlay flex-nowrap">
                      <div class="input-group-prepend-overlay">
                        <span class="input-group-text text-muted font-size-base">
                          <i class="czi-mail"></i>
                        </span>
                      </div>
                      <input class="form-control prepended-form-control" type="email" name="EMAIL" id="shopSub-EMAIL" value="" placeholder="" required>
                      <div class="input-group-append">
                        <button class="btn btn-dark" type="submit" name="subscribe">Benachrichtigen</button>
                      </div>
                    </div>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true">
                      <input type="text" name="b_c7103e2c981361a6639545bd5_29ca296126" tabindex="-1">
                    </div>
                    <small class="form-text opacity-50" id="mc-helper">Mit der Benachrichtigung erklärst du dich mit der  <router-link class="text-dark" to="datenschutz">Datenschutzerklärung</router-link> einverstanden.</small>
                    <div class="subscribe-status" id="shopSubscriptionDone"></div>
                  </form>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-10">
                <div class="row justify-content-center">
                  <div class="col-sm-4 mb-3">
                    <a class="card h-100 border-0 box-shadow-sm" href="/">
                      <div class="card-body">
                        <div class="media align-items-center">
                          <i class="czi-home text-dark h4 mb-0"></i>
                          <div class="media-body pl-3">
                            <h5 class="font-size-sm mb-0">Home</h5>
                            <span class="text-muted font-size-ms">wirkaufendeine-kueche.de</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <div class="pb-4"></div>
        </div>
      </section>
      <myFooter />
    </main>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import Vue from "vue"
import navbar from "@/components/navbar.vue"
import myFooter from "@/components/footer.vue"

export default {
  name: 'sellingSoon',
  components: {
    navbar,
    myFooter
  },
  data: () => ({
  }),
  computed: {
  },
  created: function () {
    window.myGTag('event', 'conversion', {'send_to': 'AW-717328684/9lhvCOWlvNUBEKyihtYC'});
  },
  mounted: function () {
    Vue.nextTick(() => {
      this.loadBootstrapTheme();
    });
  },
  methods: {
    loadBootstrapTheme: function () {
      let theme = document.createElement('script')
      theme.setAttribute('src', 'theme.js')
      document.head.appendChild(theme) 
    },
    shopFormSubmit: function (event) {
      if (event.target.checkValidity() === false) {
        // eslint-disable-line
      } else {
        const input = document.getElementById("shopSub-EMAIL");
        const form = document.getElementById("shopForm");
        const subDone = document.getElementById('shopSubscriptionDone');
        const userEmail = input.value.substring(0,40); 
        this.shopNotifySubmit(userEmail);
        input.value = ""; 
        form.classList.add("is-good"); 
        form.classList.remove('was-validated');
        subDone.innerHTML = 'Hey! Wir werden dich sofort benachrichtigen sobald der Marktplatz öffnet.';
        subDone.classList.add("status-success");
        event.stopPropagation();
      }
      event.preventDefault();
    }, 
    ...mapActions(['appManagerDispatch']),
    shopNotifySubmit: async function (userEmail) {
      window.myGTag('event', 'conversion', {'send_to': 'AW-717328684/3UbDCNXArNUBEKyihtYC'});
      await this.appManagerDispatch({action: "marketSignup", payload: userEmail});
    }, 
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .workingIcon {
    background-image: url("/img/myDesigns/icons/working.svg"); /* The image used */
    height: 100%;
    background-position: 90% 10%; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: fit; /* Resize the background image to cover the entire container */
  }
}
</style>